/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Last_EventInputs */

const en_cargos_last_event = /** @type {(inputs: Cargos_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Event`)
};

const es_cargos_last_event = /** @type {(inputs: Cargos_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo evento`)
};

/**
* | output |
* | --- |
* | "Last Event" |
*
* @param {Cargos_Last_EventInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_last_event = /** @type {((inputs?: Cargos_Last_EventInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Last_EventInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_last_event(inputs)
	return es_cargos_last_event(inputs)
});